var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loading"},[_c('div',{staticClass:"base-loading-content"},[_c('div',[_vm._v("受理中")]),_c('img',{attrs:{"src":"https://hopemall.oss-cn-hangzhou.aliyuncs.com/suixintao/loading.gif","width":"40%","alt":""}})])])
}]

export { render, staticRenderFns }